import React from 'react';
import usePrices from '../../hooks/usePrices';
import { GAMES, formatMad } from '../../data/servers';
import { PAGES, GAME_META, gamePath, gameLabel } from '../../site/routes';
import {
  usePageSeo, Breadcrumbs, PageHeader, Section, GamePriceTable, UpdatedNote, ServerGrid, LinkCards, CtaBand, ActionButtons
} from '../../site/ui';

export default function GamePage({ game }) {
  const { servers, updatedAt } = usePrices();
  const list = servers.filter(s => s.game === game);
  const label = gameLabel(game);
  const cheapest = Math.min(...list.map(s => s.buy));

  const breadcrumbs = [
    { label: 'Accueil', to: PAGES.home },
    { label: 'Serveurs Dofus', to: PAGES.servers },
    { label: `Kamas ${label}`, to: gamePath(game) },
  ];

  usePageSeo({
    title: `Kamas ${label} Maroc : prix et serveurs | AV Kamas`,
    description: `Achat et vente de Kamas ${label} au Maroc sur ${list.length} serveurs (${list.slice(0, 4).map(s => s.name).join(', ')}${list.length > 4 ? '…' : ''}). Dès ${formatMad(cheapest)} le million, paiement en DH.`,
    path: gamePath(game),
    breadcrumbs,
  });

  return (
    <main className="bg-gray-950 text-white">
      <Breadcrumbs items={breadcrumbs} />
      <PageHeader
        kicker={`${list.length} serveurs · dès ${formatMad(cheapest)} le million`}
        title={<>Kamas {label} : <span className="text-yellow-400">achat et vente au Maroc</span></>}
        intro={GAME_META[game].intro}
      >
        <ActionButtons className="mt-5" />
      </PageHeader>

      <Section title={`Prix des Kamas ${label}`} className="pt-0 md:pt-0">
        <div className="max-w-2xl">
          <GamePriceTable game={game} servers={list} />
        </div>
        <UpdatedNote updatedAt={updatedAt} />
      </Section>

      <Section
        title={`Les serveurs ${label}`}
        intro={`Chaque serveur ${label} a sa propre économie. Ouvrez la page d'un serveur pour son prix détaillé et la comparaison avec TryAndJudge.`}
        className="bg-gray-900/40"
      >
        <ServerGrid servers={list} />
      </Section>

      <Section title="Les autres jeux">
        <LinkCards
          columns="sm:grid-cols-2 lg:grid-cols-4"
          links={[
            ...GAMES.filter(g => g !== game).map(g => ({ to: gamePath(g), title: `Kamas ${gameLabel(g)}`, text: GAME_META[g].intro.split('.')[0] + '.' })),
            { to: PAGES.prices, title: 'Tous les prix des Kamas', text: 'Les 20 serveurs sur une seule page.' },
            { to: PAGES.comparison, title: 'Comparatif TryAndJudge', text: 'Combien vous gagnez sur chaque serveur.' },
          ]}
        />
      </Section>

      <CtaBand title={`Acheter ou vendre des Kamas ${label} ?`} />
    </main>
  );
}
